import React from "react";
import { Spinner } from "react-bootstrap";
import colors from "../theme/colors";

// Indicateur de chargement réutilisable.
function Loader({ label = "Chargement…", style }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: 20,
        color: colors.neutral,
        ...style,
      }}
    >
      <Spinner animation="border" size="sm" role="status" />
      <span>{label}</span>
    </div>
  );
}

export default Loader;
